<section class="col-seleccion">
  <ticketing-stepper></ticketing-stepper>
  <fieldset>
    <ticketing-selector-entradas *ngIf="modoPresentacion === 'LISTADO' && !continuar">
    </ticketing-selector-entradas>
    <ticketing-selector-entradas-botonera *ngIf="modoPresentacion !== 'LISTADO' && !continuar">
    </ticketing-selector-entradas-botonera>
    <router-outlet *ngIf="isContinuar()"> </router-outlet>
  </fieldset>
  <div *ngIf="!ventanaActualDePago" class="btn-continuar-wrap">
    <a
      *ngIf="!ventanaActualDePago && ventanaActualDeEntradas && modoPresentacion !== 'LISTADO'"
      class="SiguienteButton MasEntradas"
      (click)="openMasEntradasModal()"
      title="MÁS PRODUCTOS"
      >{{ 'MAS_PRODUCTOS' | translateV2 }}</a
    >
    <ticketing-siguiente-button></ticketing-siguiente-button>
    <!-- <a
      *ngIf="!ventanaActualDePago && (hayEntradasEnElCarrito() || esReservaAgrupada()) "
      class="SiguienteButton"
      (click)="avanzar()"
      title="Siguiente"
      >{{ 'SIGUIENTE' | translate }}</a
    > -->
  </div>
</section>
<!-- <ticketing-resumen-compra masEntradas="normal"></ticketing-resumen-compra> -->
<ticketing-resumen-compra></ticketing-resumen-compra>
